import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { reportsApi } from '@/lib/api';
import { toast } from 'sonner';
import Results from '@/pages/Results';

// Loads a saved report from the backend and reuses the Results page rendering
// by seeding sessionStorage.
const ReportView = () => {
  const { id } = useParams();
  const nav = useNavigate();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    reportsApi.get(id).then((data) => {
      sessionStorage.setItem('wellth_latest_report', JSON.stringify(data));
      setReady(true);
    }).catch((e) => {
      toast.error(e.response?.data?.detail || 'Could not load report');
      nav('/dashboard');
    });
  }, [id, nav]);

  if (!ready) return <div className="max-w-6xl mx-auto px-6 py-16 text-[#4A5A53] font-light">Loading your plan…</div>;
  return <Results />;
};

export default ReportView;
